<template>
  <validation-observer
    vid="stepIntroForm"
    ref="stepIntroForm"
    tag="div"
    novalidate
  >
    <vvs-input
      name="Ad Soyad"
      label="Ad Soyad"
      placeholder="Adınız Soyadınız"
      validate="required|withoutEmoji|alpha_spaces|min:3|max:255"
      maxlength="255"
      v-model="step.fullname"
      normal-label
    ></vvs-input>

    <vvs-input
      type="email"
      name="E-Posta"
      label="E-posta"
      placeholder="Lütfen e-posta adresini girin."
      validate="required|email|withoutEmoji"
      validate-mode="lazy"
      v-model="step.email"
      normal-label
    ></vvs-input>

    <vvs-input
      type="tel"
      name="Telefon"
      label="Telefon"
      placeholder="0(___) ___ __ __"
      mask="0(###) ### ## ##"
      validate="required|min:16"
      validate-mode="lazy"
      v-model="step.phoneNumber"
      normal-label
    ></vvs-input>

    <validation-provider
      name="İç Mimarlık Paket alani"
      rules="required"
      v-slot="{ errors }"
      mode="aggressive"
      slim
    >
      <vvs-control-wrapper
        label="İç Mimarlık Paket Seçimi"
        :is-required="true"
        :error="errors[0]"
        :normal-label="true"
      >
        <select v-model="step.packageCollection">
          <option :value="null" selected>Lütfen Paket Seçimi Yapınız</option>
          <option
            v-for="(option, index) in packageInfo"
            :disabled="!option.value"
            :key="index"
            :value="option.value || ''"
          >
            {{ option.text }}
          </option>
        </select>
      </vvs-control-wrapper>
    </validation-provider>

    <vvs-general-checkbox
      name="Sözleşme"
      :validate="{ required: { allowFalse: false } }"
    >
      <div>Müşteri Aydınlatma Metnini okudum, kabul ediyorum.</div>
    </vvs-general-checkbox>
    <vvs-general-checkbox v-model="step.isMarketingAccepted" name="Marketing">
      <div>
        Kampanyalardan haberdar olmak için Ticari Elektronik İleti almayı
        onaylıyorum.
      </div>
    </vvs-general-checkbox>

    <div
      class="communication-preferences-wrapper"
      v-if="step.isMarketingAccepted"
    >
      <span class="communication-preferences-wrapper__info-text"
        >Kampanya ve hizmetlerden haberdar olmak istiyorum.</span
      >
      <div class="communication-preferences-wrapper__communication-items">
        <vvs-general-checkbox v-model="step.isSMS" name="SMS">
          <div>
            SMS
          </div>
        </vvs-general-checkbox>
        <vvs-general-checkbox v-model="step.isEmail" name="E-Posta">
          <div>
            E-Posta
          </div>
        </vvs-general-checkbox>
        <vvs-general-checkbox v-model="step.isCall" name="Arama">
          <div>
            Arama
          </div>
        </vvs-general-checkbox>
      </div>
    </div>

    <policy-content></policy-content>
  </validation-observer>
</template>

<script>
import stepsMixin from './../steps.mixin';
import packageInfo from './package-info';

import PolicyContent from './policyContents';

export default {
  name: 'StepIntro',
  mixins: [stepsMixin],
  components: {
    PolicyContent,
  },
  data() {
    return {
      packageInfo,
    };
  },
};
</script>
